
import './App.css';
import Navbar from './Components/navbar';
import HeroSection from './Components/herosection';
import HowWeHelp from './Components/HowWeHelp';
import OurPortfolio from './Components/Portfolio';
import CustomCarousel from './Components/Customslider';
import ServedIndustries from './Components/IndustriesServed';
import FAQ from './Components/FAQ';
import ClientServed from './Components/ClientServed';
import Blog from './Components/Allbloglistpage';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BlogListPage from './Components/BlogList';
import BlogDetailPage from './Components/Blogdetails';
import Home from './Pages/Home';
import Footerpage from './Components/Footer';
import CountryFlags from './Components/countrysection';
import ContactUs from './Components/Contactus';
import Layout from './Components/Layout';
import AboutUs from './Components/Aboutus';
import CareersSection from './Components/carrier';
import AllBlogsPage from './Components/Allbloglistpage';
import Ourprojects from './Components/Ourprojects';
import TechnologyDevelopmentServices from './Components/Technologydevelopmentservices';
import Dataanalyticsservices from './Components/Dataanalyticsservices';
import NextGenTestingServices from './Components/NextGenTestingServices';
import AIMLservices from './Components/AI_MLservices';
import Mobileappdev from './Components/Mobileappdev';
import SalesforceCompetencies from './Components/SalesforceCompetencies';
import PowerPlatformServices from './Components/PowerPlatformServices';
import { MdOutlineRestaurantMenu } from 'react-icons/md';
import OurTeam from './Components/ourteam';
import CookieConsent from './Components/CookiesConsent';

function App() {
  return (
    <div className="App">
       {/* <Navbar />
       <HeroSection/>
       <HowWeHelp/>
       <OurPortfolio/>
       <CustomCarousel/>
       <ServedIndustries/> */}
      <Router>
        <CookieConsent/>
         <Layout>
        <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/client" element={<ServedIndustries />} />
            <Route path="/blog/:id" element={<BlogDetailPage />} />
            <Route path="/Blog" element={<AllBlogsPage />} />
            <Route path="/Contact-us" element={<ContactUs/>} />
            <Route path="/About-Us" element={<AboutUs/>} />
            <Route path="/Our-Team" element={<OurTeam/>} />
           <Route path="/Career" element={<CareersSection/>} />
           <Route path="/technology-developmen-services" element={<TechnologyDevelopmentServices/>} />
           <Route path="/data-analytics-services" element={<Dataanalyticsservices/>} />
           <Route path="/next-genTesting-services" element={<NextGenTestingServices/>} />
           <Route path="/aiml-services" element={<AIMLservices/>} />
           <Route path="/mobile-app-devlopment-services" element={<Mobileappdev/>} />  
           <Route path="/sales-force-competencies-services" element={<SalesforceCompetencies/>} /> 
           <Route path="/power-platform-services" element={<PowerPlatformServices/>} />
           {/* <Route path="/Ourprojects" element={<Ourprojects/>} /> */}
        </Routes>
        </Layout>
    </Router>
    </div>
  );
}

export default App;
